export function mobileEntryRoute({
  pathname,
  search,
  mobile,
  deterministic,
}: {
  pathname: string;
  search: string;
  mobile: boolean;
  deterministic: boolean;
}): '/explore' | undefined {
  if (pathname !== '/' || !mobile || deterministic) return undefined;
  const params = new URLSearchParams(search);
  if (params.has('fixture') || params.get('guide') === '1') return undefined;
  return '/explore';
}
